export default (function () {
  // Header Menu
  $('.header-btn').click(function () {
    $('body').toggleClass('open-nav');
  }); // End Page Arrow

  $(window).scroll(function () {
    $('body').removeClass('end-page');

    if ($(window).scrollTop() + $(window).height() > $(document).height() - 100) {
      $('body').addClass('end-page');
    }
  });
  $('.header-arrow').on('click', function () {
    $('html, body').animate({
      scrollTop: 0
    }, 500);
  }); // Slider Hero

  var appHeight = function appHeight() {
    var doc = document.documentElement;
    doc.style.setProperty('--app-height', "".concat(window.innerHeight, "px"));
  };

  window.addEventListener('resize', appHeight);
  appHeight();
  $('.slider-hero').slick({
    dots: false,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: false,
    pauseOnFocus: false
  }); // Tabs Workspace

  $('.tabs__nav').on('click', 'li:not(.active)', function () {
    $(this).addClass('active').siblings().removeClass('active').closest('.tabs').find('.tabs__content').removeClass('active').eq($(this).index()).addClass('active');
  }); // Slider Floor Plans

  $('.slider-floor-plans').slick({
    dots: false,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    appendArrows: $('.slider-control'),
    prevArrow: "<button type='button' class='slick-prev slick-arrow'><i class='icon-arrow'></i></button>",
    nextArrow: "<button type='button' class='slick-next slick-arrow'><i class='icon-arrow'></i></button>"
  }); // Slider Location

  $('.slider-location').slick({
    dots: false,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    appendArrows: $('.slider-control'),
    prevArrow: "<button type='button' class='slick-prev slick-arrow'><i class='icon-arrow'></i></button>",
    nextArrow: "<button type='button' class='slick-next slick-arrow'><i class='icon-arrow'></i></button>"
  }); // Gallery Popup

  $('[data-fancybox="gallery"]').fancybox({
    toolbar: false,
    loop: true,
    infobar: false,
    idleTime: false,
    arrows: false,
    touch: false,
    smallBtn: true,
    mobile: {
      touch: true
    },
    btnTpl: {
      smallBtn: '<button type="button" data-fancybox-close class="fancybox-button-close"><i class="icon icon-close"></i></button>'
    },
    afterLoad: function afterLoad(instance, current) {
      var $currentSlide = current.index + 1;
      var $groupSlide = instance.group.length;

      if ($currentSlide < 10) {
        $currentSlide = '0' + $currentSlide;
      }

      if ($groupSlide < 10) {
        $groupSlide = '0' + $groupSlide;
      }

      if (instance.group.length > 1 && current.$content && current.$content.find(".fancybox-button").length < 2) {
        current.$content.append('<div class="fancybox-infobar-wrap"><span>' + $currentSlide + '</span> / <span>' + $groupSlide + '</span></div><div class="fancybox-button-wrap"><button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left"><i class="icon icon-arrow-small"></i></button><button data-fancybox-next class="fancybox-button fancybox-button--arrow_right"><i class="icon icon-arrow-small"></i></button></div>');
      }
    }
  });
  $(".video-link").fancybox({
    type: "video",
    iframe: {
      preload: false
    }
  });
});